<template>
    <convenio-detalhar
        :dataServicos="obterDataServicos()"
        rotaListagem="Gescon_Convenios_Financeiro"
        :temAcessoAcoesPlanoTrabalho="$temAcessoView('GESCON-FINAN-CONV-PLANO-00')"
        :temAcessoEventos="$temAcessoView('GESCON-FINAN-CONV-EVENTO-00')"
        :temAcessoPrestacaoMensal="$temAcessoView('GESCON-FINAN-CONV-PLANO-00')"
        :temAcessoDocumentosEvento="$temAcessoView('GESCON-FINAN-CONV-PLANO-00')"
        :temAcessoMetas="$temAcessoView('GESCON-FINAN-CONV-PLANO-00')"    
        :temAcessoPrestacaoFinal="$temAcessoView('GESCON-FINAN-CONV-PLANO-00')"
        :permiteAcessarDocumentos="$temAcessoView('GESCON-FINAN-CONV-PLANO-00')"
        
    ></convenio-detalhar>
</template>

<script>
import ConvenioDetalhar from '../componentes/detalhes/ConvenioDetalhes'
import ConveniosServicos from './ConvenioServicos'

export default {
    components: {
        ConvenioDetalhar
    },

    methods: {
        obterDataServicos() {
            return ConveniosServicos
        }
    }
}
</script>